<div fxLayout="row" fxLayoutAlign="center center" class="mt-15">
  <mat-card appearance="outlined" fxFlex="90" fxFlex.gt-sm="40" class="p-0 mat-elevation-z6 box">
    <div
      fxLayout="column"
      fxLayoutAlign="center center"
      class="bg-primary box-header"
    >
      <mat-icon class="mat-icon-xlg">error</mat-icon>
      <h1 class="error">403</h1>
    </div>
    <mat-card-content
      fxLayout="column"
      fxLayoutAlign="center center"
      fxLayoutGap="20px"
      class="box-content"
    >
      <div
        fxLayout="column"
        fxLayoutAlign="center center"
      >
        <p class="box-text">
          {{ 'not-authorized-page' | translate }}
        </p>
      </div>
      <div class="box-footer">
        @if (isMessageCenterPath) {
          <button mat-raised-button color="primary" class="mat-elevation-z8" type="button" (click)="logout()" [attr.aria-label]="'logout' | translate">
            <mat-icon class="m-0">logout</mat-icon>
          </button>
        } @else {
          <button mat-raised-button color="primary" class="mat-elevation-z8" type="button" (click)="goHome()" aria-label="Home">
            <mat-icon class="m-0">home</mat-icon>
          </button>
        }
      </div>
    </mat-card-content>
  </mat-card>
</div>
